import {
  GET_PARTNER_ACCOUNT,
  GET_PARTNER_ACCOUNT_SUCCESS,
  GET_PARTNER_ACCOUNT_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  partnerAccounts: [],
};

const getIbPartnerAccountReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PARTNER_ACCOUNT:
      return { ...state, loading: true };
    case GET_PARTNER_ACCOUNT_SUCCESS:
      return {
        ...state,
        details: action?.payload,
        loading: false,
      };
    case GET_PARTNER_ACCOUNT_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default getIbPartnerAccountReducer;
